import { useState, useEffect } from 'react';
import axios from 'axios';

import { API_URL } from '../config/api';

export const useZones = () => {
  const [zones, setZones] = useState([]);

  useEffect(() => {
    const fetchZones = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/property/zones`, { withCredentials: true });
        setZones(res.data);
      } catch (error) {
        // No property/zones yet — that's expected for new users
        console.debug('Zones not available:', error.message);
      }
    };
    fetchZones();
  }, []);

  return zones;
};
